import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

import { Container } from '../components/tables/Style';
import { AddButton } from '../components/tables/Buttons';
import { InputArea } from './Styles/Inputs';

import { addToCollection, queryCollection } from '../services/database';

const EditNewsMeta = ({ history }) => {
    const [inputs, setInputs] = useState({
        metadescription: '',
        ogtitle: '',
        ogdescription: '',
        ogurl: '',
        keywords: '',
        title: '',
        description: ''
    });

    useEffect(() => {
        if (!history?.location?.state?.id) return;

        queryCollection('news', 'id', '==', parseInt(history.location.state.id))
            .then(result => {
                if (result?.data?.length > 0) {
                    const data = result.data[0];
                    setInputs({
                        metadescription: data.metadescription || '',
                        ogtitle: data.ogtitle || '',
                        ogdescription: data.ogdescription || '',
                        ogurl: data.ogurl || '',
                        keywords: data.keywords || '',
                        title: data.title || '',
                        description: data.description || ''
                    });
                }
            });
    }, [history]);

const handleSubmit = async () => {
    const id = history.location.state.id;

    try {
        // Pokušaj dohvatiti postojeći dokument
        const result = await queryCollection('news', 'id', '==', parseInt(id));

        if (!result?.data?.length) {
            alert("❌ Vijest sa ovim ID-em ne postoji. Ne možeš dodavati meta podatke dok osnovni sadržaj nije kreiran.");
            return;
        }

        const existingData = result.data[0];

        // Ažuriramo samo meta polja, ostalo ostaje netaknuto
        const updatedData = {
            ...existingData, // zadržavamo sve postojeće podatke
            metadescription: inputs.metadescription,
            ogtitle: inputs.ogtitle,
            ogdescription: inputs.ogdescription,
            ogurl: inputs.ogurl,
            keywords: inputs.keywords,
            title: inputs.title,
            description: inputs.description
        };

        await addToCollection('news', id.toString(), updatedData);
        history.push('/news');
    } catch (error) {
        console.error("❌ Greška prilikom čuvanja:", error);
        alert("Došlo je do greške prilikom čuvanja.");
    }
};


    const renderInput = (label, field) => (
        <>
            <h1 style={{ color: '#fff' }}>{label}:</h1>
            <InputArea
                rows={3}
                onChange={e => setInputs({ ...inputs, [field]: e.target.value })}
                value={inputs[field]}
            />
        </>
    );

    return (
        <Container>
            {renderInput('Meta Description', 'metadescription')}
            {renderInput('OG Title', 'ogtitle')}
            {renderInput('OG Description', 'ogdescription')}
            {renderInput('OG URL', 'ogurl')}
            {renderInput('Keywords', 'keywords')}
            {renderInput('Naslov (Title)', 'title')}
            {renderInput('Opis (Description)', 'description')}

            <AddButton onClick={handleSubmit}>
                <i className="fas fa-save"></i>
                <h1>Sačuvaj</h1>
            </AddButton>
        </Container>
    );
};

export default withRouter(EditNewsMeta);
